export enum NoChatNextView {
    Welcome = "Welcome",
    PreviousChatClosed = "PreviousChatClosed",
    LiveFeedback = "LiveFeedback",
    BotFeedback = "BotFeedback",
    Error = "Error",
}
